/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Model from '@tripian/model';
import { Home } from '../base/Svg/Icons';
import classes from './AccommondationCard.scss';

interface IAccommondationCard {
  accommodation: Model.Accommodation;
  clicked: (accommodation: Model.Accommodation) => void;
}

const AccommondationCard: React.FC<IAccommondationCard> = ({ accommodation, clicked }) => (
  <div
    className={classes.accommodation}
    onKeyDown={() => {}}
    role="button"
    tabIndex={0}
    onClick={() => {
      clicked(accommodation);
    }}
  >
    <div className={classes.icon}>
      <Home size="1.875rem" />
    </div>
    <div className={classes.info}>
      <div className={classes.title}>{accommodation.name}</div>
      <div className={classes.address}>{accommodation.address}</div>
    </div>
  </div>
);

export default AccommondationCard;
